const STORAGE_USER_KEY = 'triiderUser';
const STORAGE_REFRESH_MUTEX_KEY = '@triider:refresh-token';

export const updateLocalTokens = (token, refreshToken) => {
  const user = JSON.parse(localStorage.getItem(STORAGE_USER_KEY));
  const newUser = {
    ...user,
    refreshToken,
    token,
  };

  localStorage.setItem(STORAGE_USER_KEY, JSON.stringify({ ...newUser }));
};

export const getUser = () => JSON.parse(localStorage.getItem(STORAGE_USER_KEY));

export const deleteUser = () => {
  localStorage.removeItem(STORAGE_USER_KEY);
};

export const getRefreshMutex = () => localStorage.getItem(STORAGE_REFRESH_MUTEX_KEY);

export const setRefreshMutex = (value) => {
  localStorage.setItem(STORAGE_REFRESH_MUTEX_KEY, value);
};

export const deleteRefreshMutex = () => {
  localStorage.removeItem(STORAGE_REFRESH_MUTEX_KEY);
};
